import { createFileRoute } from "@tanstack/react-router"

import { PageContent } from "@/components/common/page-content"
import { PageHeader } from "@/components/common/page-header"
import { IndividualFitness } from "@/features/individuals/components/individual-fitness"
import { FitnessHeaderActions } from "@/features/individuals/components/individual-fitness-actions"
import { fitnessQueries } from "@/queries/fitness"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/individuals/$individualId/fitness/"
)({
  staticData: { attention: "individual.fit_and_proper" },
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(
      fitnessQueries.list(params.individualId)
    ),
  component: IndividualFitnessPage,
})

function IndividualFitnessPage() {
  const { individualId } = Route.useParams()

  return (
    <>
      <PageHeader
        title="Fit and proper"
        actions={<FitnessHeaderActions individualId={individualId} />}
      />

      <PageContent>
        <IndividualFitness individualId={individualId} />
      </PageContent>
    </>
  )
}
